import {
  AddressForm,
  Button,
  ButtonBorder,
  Div,
  HeaderBack,
  ImageView,
  Label,
  LoadingIndicator,
} from 'components';
import {Ecolors, Efonts, Icons} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {Alert, ScrollView} from 'react-native';
import {
  getInvestmentProfile,
  getStatusEditProfile,
} from 'reducer/authen/selector';
import {apiAuth, goBack, navigate, useImageUrl} from 'services';
import {apiMain} from 'services/apis/apiMain';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {Log} from 'utils';
import {convertchangeIdNoStatus} from '../ChangeCMNDtoCCCDScreen/api';
import {getInfo} from 'reducer/authen';

function RowSpaceItem(p: {paddingTop?: number; children?: any}) {
  return (
    <Div
      minHeight={54}
      paddingHorizontal={16}
      borderBottomWidth={1}
      borderBottomColor={Ecolors.bgtime}
      paddingTop={p.paddingTop ?? 0}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}>
      {p.children && p.children}
    </Div>
  );
}

function AddressInfoModal() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  //
  const I18nState = useAppSelector(state => state.languages.I18nState);
  //
  const [permanentCountry, setPermanentCountry] = useState<any>(null);
  const [permanentProvince, setPermanentProvince] = useState<any>(null);
  //
  const [mailingCountry, setMailingCountry] = useState<any>(null);
  const [mailingProvince, setMailingProvince] = useState<any>(null);
  //

  const currentUser = useAppSelector(state => state.authen.currentUser);
  const {
    permanentAddress,
    countryId,
    provinceId,
    mailingAddress,
    mailingCountryId,
    mailingProvinceId,
    changeAddressInfoStatus,
    investmentProfile,
    userAddressIsFull,
    changeAddressInfo,
    addressChangeAttachmentUrl,
  } = currentUser;

  const [imageSource, firstLoadingImg] = useImageUrl(
    `download/file-for-link`,
    'POST',
    `${addressChangeAttachmentUrl}`,
  );

  const iconEdit = () => {
    const currentProfileStatus = investmentProfile?.status?.code;

    const statuses = [
      'INVESTMENT_PROFILE_ACCEPT',
      'INVESTMENT_PROFILE_APPROVE',
    ];

    const isProfileApproved = statuses.includes(currentProfileStatus);

    if (
      !userAddressIsFull || // Mới tạo account, chưa điền đầy đủ thông tin
      (isProfileApproved && changeAddressInfo == 1) || // Đã xác thực và trạng thái là approved hoặc reject
      !currentProfileStatus // Chưa xác thực
    ) {
      return Icons.edit;
    }
    return null;
  };

  const isShowVnid =
    !!addressChangeAttachmentUrl &&
    (investmentProfile?.status?.code === 'INVESTMENT_PROFILE_ACCEPT' ||
      investmentProfile?.status?.code === 'INVESTMENT_PROFILE_APPROVE');

  useEffect(() => {
    bindData();
    return () => {};
  }, []);

  const bindData = async () => {
    try {
      setLoading(true);
      await dispatch(getInfo({}));
      const res = await Promise.all([
        apiMain.getCountry(),
        apiMain.getProvince({countryId: countryId}),
        apiMain.getProvince({countryId: mailingCountryId}),
      ]);
      const PCountry = res[0]?.data?.find((a: any) => a.id == countryId);
      const PProvince = res[1]?.data?.find((a: any) => a.id == provinceId);
      const MCountry = res[0]?.data?.find((a: any) => a.id == mailingCountryId);
      const MProvince = res[2]?.data?.find(
        (a: any) => a.id == mailingProvinceId,
      );
      setMailingCountry(MCountry || null);
      setMailingProvince(MProvince || null);
      setPermanentCountry(PCountry || null);
      setPermanentProvince(PProvince || null);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        loading={loading}
        type={2}
        iconRight={iconEdit()}
        onRightPress={() => {
          navigate('EditAddressInfoModal', {
            data: {
              permanentAddress,
              permanentProvince,
              permanentCountry,
              //
              mailingAddress,
              mailingProvince,
              mailingCountry,
            },
          });
        }}
        title={`accountverify.thongtindiachi`}
      />
      <ScrollView>
        {!!changeAddressInfoStatus && (
          <Button
            onPress={() => {
              navigate('ChangeCMNDtoCCCDDetailsScreen', {change: 'address'});
            }}>
            <RowSpaceItem>
              <Label>{`changecmnd.trangthaihoso`}</Label>
              <Div
                flexDirection="row"
                alignItems="center"
                justifyContent="flex-end">
                <Label
                  style={{fontStyle: 'italic'}}
                  color={convertchangeIdNoStatus(changeAddressInfoStatus).color}
                  multilanguage={false}>
                  {convertchangeIdNoStatus(changeAddressInfoStatus).title}
                </Label>
                <ImageView
                  marginLeft={5}
                  widthHeight={12}
                  source={Icons.forward}
                  resizeMode="contain"
                />
              </Div>
            </RowSpaceItem>
          </Button>
        )}
        <Div padding={16} backgroundColor={Ecolors.bgtime}>
          <Label multilanguage={false}>
            {`1. `}
            <Label>{`accountverify.diachithuongtru`}</Label>
          </Label>
        </Div>
        <RowSpaceItem>
          <Label>{`accountverify.quocgia`}</Label>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            paddingVertical={13}
            flex={1}
            paddingLeft={16}>
            <Label multilanguage={false}>
              {I18nState == 'vi'
                ? permanentCountry?.name
                : permanentCountry?.nameEn || ''}
            </Label>
          </Div>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.tinhthanhpho`}</Label>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            paddingVertical={13}
            flex={1}
            paddingLeft={16}>
            <Label multilanguage={false}>
              {I18nState == 'vi'
                ? permanentProvince?.name
                : permanentProvince?.nameEn || ''}
            </Label>
          </Div>
        </RowSpaceItem>

        <RowSpaceItem>
          <Label>{`accountverify.diachithuongtru`}</Label>

          <Label
            style={{paddingLeft: 10, textAlign: 'right', flex: 1}}
            multilanguage={false}>
            {permanentAddress}
          </Label>
        </RowSpaceItem>

        {isShowVnid && imageSource.url && (
          <Div style={{paddingLeft: 16, paddingTop: 16, paddingBottom: 16}}>
            <Label>{`accountverify.vnid`}</Label>
            <Div style={{borderRadius: 6, paddingTop: 10, paddingBottom: 6}}>
              <ImageView
                style={{borderRadius: 6}}
                resizeMode="cover"
                width={162}
                height={103}
                source={{
                  uri: imageSource.url || '',
                }}
              />
              {firstLoadingImg && !imageSource.url && (
                <Div
                  style={{
                    position: 'absolute',
                    top: 10,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: 6,
                  }}
                  alignItems={'center'}
                  justifyContent={'center'}
                  width={162}
                  height={103}
                  backgroundColor={Ecolors.transparentLoading}>
                  <LoadingIndicator color={Ecolors.mainColor} />
                </Div>
              )}
            </Div>
          </Div>
        )}

        <Div padding={16} backgroundColor={Ecolors.bgtime}>
          <Label multilanguage={false}>
            {`2. `}
            <Label>{`accountverify.diachilienhe`}</Label>
          </Label>
        </Div>
        <RowSpaceItem>
          <Label>{`accountverify.quocgia`}</Label>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            paddingVertical={13}
            flex={1}
            paddingLeft={16}>
            <Label multilanguage={false}>
              {I18nState == 'vi'
                ? mailingCountry?.name
                : mailingCountry?.nameEn || ''}
            </Label>
          </Div>
        </RowSpaceItem>
        <RowSpaceItem>
          <Label>{`accountverify.tinhthanhpho`}</Label>
          <Div
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'flex-end'}
            paddingVertical={13}
            flex={1}
            paddingLeft={16}>
            <Label multilanguage={false}>
              {I18nState == 'vi'
                ? mailingProvince?.name
                : mailingProvince?.nameEn || ''}
            </Label>
          </Div>
        </RowSpaceItem>

        <RowSpaceItem>
          <Label>{`accountverify.diachilienhe`}</Label>

          <Label
            style={{paddingLeft: 10, textAlign: 'right', flex: 1}}
            multilanguage={false}>
            {mailingAddress}
          </Label>
        </RowSpaceItem>
      </ScrollView>
    </Div>
  );
}

export default React.memo(AddressInfoModal);
